import React from "react";

import { useHistory } from "react-router-dom";

import { Box, Button, Flex, Icon, Text, AvatarGroup } from "@chakra-ui/react";
import { ArrowLeftIcon } from "@heroicons/react/outline";
import { UserAvatarWithRole } from "../../utils/chakra/AvatarWithTooltip";

import useTranslations from "../../../hooks/useTranslations";
import useFormatDate from "../../../hooks/useFormatDate";

import { ReportFragment } from "../../../graphql/generated/definitions";

export default function ReportFormHeader({
  report,
}: {
  report: ReportFragment;
}) {
  const t = useTranslations();
  const history = useHistory();
  const formattedReportDate = useFormatDate({
    date: report.createdAt,
    format: "short",
  });
  const collaborator = report.review.collaborator;

  return (
    <Flex
      bgColor="darkBrand"
      direction="column"
      roundedTop={["none", "md"]}
      pb={["10"]}
      pt="8"
      px={["6", "16"]}
    >
      <Box>
        {/* FIXME: Should be invertedSecondary variant */}
        <Button
          onClick={history.goBack}
          leftIcon={<Icon as={ArrowLeftIcon} />}
          ml="-2"
          colorScheme="gray"
          color="white"
          _hover={{
            color: "darkBrand",
            bgColor: "gray.50",
          }}
          variant="ghost"
          size="sm"
        >
          {t("reports.shared.back")}
        </Button>
        <Text fontSize="xs" color="white" pt="4">
          {formattedReportDate}
        </Text>
        <Flex direction={["column", "row"]}>
          <Flex direction="column">
            <Flex experimental_spaceX="3" alignItems="center">
              <Text fontSize="3xl" fontWeight="semibold" color="white">
                {collaborator.name}
              </Text>
              <UserAvatarWithRole
                src={collaborator.avatar}
                name={collaborator.name}
                role={t("reports.shared.role.collaborator") as string}
                rootProps={{
                  avatarProps: {
                    size: "sm",
                    display: ["none", "inline-flex"],
                  },
                }}
              />
            </Flex>
            <Text
              fontSize="md"
              fontWeight="semibold"
              color="white"
              pt={["0", "3"]}
            >
              {report.review.template.title}
            </Text>
          </Flex>
          <Flex
            justify={["start", "flex-end"]}
            pt={["3", "1.5"]}
            alignItems="start"
            pl={["0", "3"]}
            flexGrow={1}
          >
            <UserAvatarWithRole
              src={collaborator.avatar}
              name={collaborator.name}
              role={t("reports.shared.role.collaborator") as string}
              rootProps={{
                avatarProps: {
                  size: "sm",
                  display: ["inline-flex", "none"],
                },
              }}
            />
            <AvatarGroup pl={["3", "0"]} max={10} size="sm" spacing={2}>
              {report.reportReferents.map(({ referent }) => (
                <UserAvatarWithRole
                  key={referent.id}
                  src={referent.avatar}
                  name={referent.name}
                  role={t("reports.shared.role.referent") as string}
                  rootProps={{
                    avatarProps: {
                      size: "sm",
                    },
                  }}
                />
              ))}
            </AvatarGroup>
          </Flex>
        </Flex>
      </Box>
    </Flex>
  );
}
